module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_5.d9f4dfd6.png";